import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

import { UserGuard } from './core/guards/user.guard';
import { LoginGuard } from './core/guards/login.guard';
import { DBService } from './core/services/db.service';

const routes: Routes = [
	{
		path: 'tabs',
		loadChildren: () => import('./features/tabs/tabs.module').then(m => m.TabsPageModule),
		canLoad: [UserGuard],
	},
	{
		path: 'login',
		loadChildren: () => import('./features/users/users.module').then(m => m.UsersModule),
		canLoad: [LoginGuard],
		resolve: { dbService: DBService }
	},
	{
		path: '',
		redirectTo: '/tabs',
		pathMatch: 'full',
	},
];
@NgModule({
	imports: [
		RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
	],
	exports: [RouterModule]
})
export class AppRoutingModule { }
